"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const app_service_1 = require("../../../../commons/app.service");
const router_1 = require("@angular/router");
const map_service_1 = require("../../../../commons/map.service");
const main_service_1 = require("../../../main.service");
const common_1 = require("@angular/common");
const http_1 = require("@angular/common/http");
const map_component_1 = require("../../map.component");
const core_2 = require("@ngx-translate/core");
const AppBaseComponent_1 = require("../../../../commons/AppBaseComponent");
const index_1 = require("rxjs/index");
const operators_1 = require("rxjs/operators");
const application_events_service_1 = require("../../../../xs/services/events/application-events.service");
const Constants_1 = require("../../../../commons/Constants");
class TerrainCompareComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, r, sn, d, t, mainService, trans, mapService, httpClient, ar, mapComp, location, applicationEvents) {
        super(service, r, sn, d, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.r = r;
        this.t = t;
        this.mainService = mainService;
        this.trans = trans;
        this.mapService = mapService;
        this.httpClient = httpClient;
        this.ar = ar;
        this.mapComp = mapComp;
        this.location = location;
        this.debug = Constants_1.Constants.debug_off;
        this.allSceneTransformsA = [];
        this.allSceneTransformsB = [];
        this.mapComp.detailsNav.open();
    }
    compare() {
        this.createJob();
        this.navigateBack(this.location);
    }
    createJob() {
        if (this.selectedDesignTransformA && this.selectedDesignTransformB && this.selectedDesignTransformA.id === this.selectedDesignTransformB.id) {
            this.openSnackBarError('MAP.TERRAIN.COMPARE_ERROR');
            return;
        }
        var jobType = this.fourD.jobTypes.find(jt => jt['uid'] == 'terrain-compare');
        if (this.debug) {
            console.log('terrain-compare.ts :: createJob() jobType', jobType);
        }
        var job = new _4d_mapper_1.Job(this.fourD.V).set({
            name: this.transform ? this.transform.name : this.selectedDesignTransformA.name,
            account: this.fourD.activeTeam,
            jobType: jobType,
            scene: this.mapService.scene,
            // group: this.group,
            amountPaid: false,
            compareTransformFrom: this.transform ? this.transform.id : this.selectedDesignTransformA.id,
            compareTransformTo: this.selectedDesignTransformB.id,
            compareDatasetFrom: this.transform ? this.transform.input.id : this.selectedDesignTransformA.input.id,
            compareDatasetTo: this.selectedDesignTransformB.input.id
        }).saveObservable()
            .pipe(operators_1.flatMap(job => 
        // add the 2 terains to the job
        index_1.forkJoin([
            job.inputDatasets.addObserveable(this.transform ? this.transform.input : this.selectedDesignTransformA.input),
            job.inputDatasets.addObserveable(this.selectedDesignTransformB.input)
        ]).pipe(operators_1.map(_ => job)))).subscribe(res1 => {
            let params = {};
            let sceneName;
            if (this.transform) {
                params['A'] = encodeURIComponent(this.transform['ds_name']);
                sceneName = this.transform['ds_name'];
            }
            else {
                params['A'] = encodeURIComponent(this.selectedDesignTransformA['ds_name']);
                sceneName = this.selectedDesignTransformA['ds_name'];
            }
            params['B'] = encodeURIComponent(this.selectedDesignTransformB['ds_name']);
            sceneName += ' - ' + this.selectedDesignTransformB['ds_name'];
            params['name'] = sceneName;
            if (this.debug) {
                console.log('terrain-compare.ts :: createJob() params', params);
            }
            res1.startTransform(jobType.baseTransform, params).subscribe(v => {
                this.openSnackBarInfo('MAP.TERRAIN.COMPARE_PROCESSING');
                if (this.debug) {
                    console.log('terrain-compare.ts :: createJob() starting', res1, v);
                }
                this.mapService.terranCompareStarted.next(res1.id);
            }, error1 => {
                this.openSnackBarSuccess('GENERIC.ERROR');
            });
        }, error1 => {
            this.openSnackBarSuccess('GENERIC.ERROR');
        });
    }
    cancel() {
        this.navigateBack(this.location);
    }
    ngAfterViewInit() {
        this.addSubscription('ar-params', this.ar.params.subscribe(p => {
            let trans = this.mapService.sceneTransforms.filter(v => v.id == p.transformId);
            this.transform = trans[0];
        }));
        this.mapService.scenes.forEach(s => {
            if (s._cachedTransforms) {
                // get all unique transforms from all scenes
                s._cachedTransforms.forEach(ct => {
                    if (this.allSceneTransformsA.findIndex(t => t.id === ct.id) === -1 && ct['type_uid'] === 'terrain-tiles') {
                        this.allSceneTransformsA.push(ct);
                    }
                });
                // get all unique transforms from all scenes
                s._cachedTransforms.forEach(ct => {
                    if (this.allSceneTransformsB.findIndex(t => t.id === ct.id) === -1 && ct['type_uid'] === 'terrain-tiles') {
                        this.allSceneTransformsB.push(ct);
                    }
                });
            }
            else { // if cached transforms is not available then fetch it, this happens when terrain compare result is ready and user try to compare again
                s.children.queryObservable().subscribe(ct => {
                    if (ct && ct.items.length > 0) {
                        // get all unique transforms from all scenes
                        ct.items.forEach(ct => {
                            if (this.allSceneTransformsA.findIndex(t => t.id === ct.id) === -1 && ct['type_uid'] === 'terrain-tiles') {
                                this.allSceneTransformsA.push(ct);
                            }
                        });
                        // get all unique transforms from all scenes
                        ct.items.forEach(ct => {
                            if (this.allSceneTransformsB.findIndex(t => t.id === ct.id) === -1 && ct['type_uid'] === 'terrain-tiles') {
                                this.allSceneTransformsB.push(ct);
                            }
                        });
                    }
                });
            }
        });
    }
    destroy() {
        this.mapService.inTerrainCompare = false;
    }
}
exports.TerrainCompareComponent = TerrainCompareComponent;
